export enum LikeSuccessStatusEnum {
  CREATE = 'create',
  REMOVE = 'remove',
}
